const brokerConsultMiFID = require('./brokerConsultMiFID');
const brokerConvenienceMiFIDTest = require('./brokerConvenienceMiFIDTest');
const brokerMiFIDDisplayed = require('./brokerMiFIDDisplayed');
const brokerMiFIDProducts = require('./brokerMiFIDProducts');
const brokerMiFIDUSPerson = require('./brokerMiFIDUSPerson');

module.exports = {
    brokerConsultMiFID,
    brokerConvenienceMiFIDTest,
    brokerMiFIDDisplayed,
    brokerMiFIDProducts,
    brokerMiFIDUSPerson
}